import { render, staticRenderFns } from "./resetPasswordRedirect.vue?vue&type=template&id=53d7e9d2&"
import script from "./resetPasswordRedirect.vue?vue&type=script&lang=js&"
export * from "./resetPasswordRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports